import { render, staticRenderFns } from "./_promotionModal.vue?vue&type=template&id=49b2d838"
import script from "./_promotionModal.vue?vue&type=script&lang=js"
export * from "./_promotionModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports